
<div class="container-fluid">
    <div class="content-container p-4">
        <ng-container *ngIf="totalRecordCount > 0">
            <table class="im-card-no-border-table table im-card-table-noborder-spacing table-header_uppercase table-striped-simple" mat-table [dataSource]="dataSource" matSort>
                <ng-container *ngFor="let column of columns" [matColumnDef]="column.columnDef">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{column.header}} </th>
                    <td mat-cell *matCellDef="let row" [ngClass]="[column.columnDef == 'comment' ? 'mat-cell-wrap-text1' : '']">
                        <span *ngIf="column.columnDef =='status'">
                            <span [ngClass]="{'live-status': row.status?.name == 'Live', 'take-down-status': row.status?.name == 'Take Down'}">
                                <span *ngIf="row.status?.name == 'Take Down'; else postedLcaStatus">Taken Down</span>
                                <ng-template #postedLcaStatus>
                                    <span>{{row.status?.name}}</span>
                                </ng-template>
                            </span>
                        </span>
                        <span *ngIf="column.columnDef =='visaType'">
                            {{row.visaType?.code}}
                        </span>
                        <span *ngIf="column.columnDef =='employmentStartDate' || column.columnDef =='employmentEndDate'">
                            {{row[column.columnDef] | ImgDateFormat}}
                        </span>
                        <span *ngIf="column.columnDef !=='visaType' && column.columnDef !=='status' && column.columnDef !=='employmentStartDate' && column.columnDef !=='employmentEndDate' && column.columnType !=='icon'">
                            {{row[column.columnDef]}}
                        </span>
                        <span class="column.customClass" *ngIf="column.columnType=='icon'">
                            <ng-container *ngIf="row.status?.name == 'Assign'">
                                <div *ngFor="let document of row.documents">
                                    <a *ngIf="document.fileCategory.code === 'LCA'" [href]="envPath + document.fileLocation.substring(23)" target="_blank" download>
                                        <i class="fa fa-eye" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </ng-container>
                        </span>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                </tr>
            </table>
        </ng-container>
        <div class="no-data" *ngIf="totalRecordCount === 0">
            <h6>No Data Found!</h6>
        </div>
    </div>
</div>


